import React, { useEffect } from 'react';
// عکس را دانلود کرده و در پوشه assets پروژه ذخیره کنید، سپس خط زیر را آنکومنت کنید:
// import yogaImg from './assets/yoga-pose.png';

function YogaDemo() {
  useEffect(() => {
    const timer = setInterval(() => {
      const warningLine = document.getElementById('warning-skeletal-line');
      if (warningLine) {
        warningLine.style.opacity = (Math.random() * 0.4 + 0.6).toFixed(2);
      }
    }, 800);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      backgroundColor: '#050508',
      color: '#ffffff',
      width: '100%',
      aspectRatio: '16/9',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'relative',
      fontFamily: 'Vazirmatn, Tahoma, sans-serif'
    }} dir="rtl">

      {/* تصویر ورزشکار (برای آفلاین شدن، عکس را از پوشه محلی خوانده و src={yogaImg} بگذارید) */}
      <div style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img 
          alt="حرکت یوگا" 
          style={{ width: '90%', height: '90%', objectFit: 'contain', opacity: 0.7 }} 
          src="https://lh3.googleusercontent.com/aida-public/AB6AXuA5XSqLEliAwssztpupnwao-JnIxrZuDO1CE6y_szwPPB7hQxMgSw5b_AM4esQP6yYTr6iyM6EGm5uga3thTy75l5HAlYHC_CAXHDCoMewjPlV8r0ZDUGQCK69JnDRwo_GzGC876GPM3wN6_vFpTXXjSMGOSpRwiD_P-mQReRVcpDcySVJqskxjn9mnyRLoXbKoCK30FYflI20hSVio-8jNX3WfXsTGhZRh2BvXnPmKFhIBiU4zf_tBs6HKUepf6PpQMYQxrb_EesAU" 
        />
        
        {/* پردازش اسکلتی بنفش و قرمز خطا */}
        <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 10 }} preserveAspectRatio="xMidYMid slice" viewBox="0 0 1000 600">
          <g strokeLinecap="round" strokeWidth="5" style={{ opacity: 0.95 }}>
            <line x1="500" x2="500" y1="200" y2="350" stroke="#9d55ff"></line>
            <line x1="420" x2="580" y1="220" y2="220" stroke="#9d55ff"></line>
            <line x1="420" x2="280" y1="220" y2="220" stroke="#7a22ff" strokeWidth="6"></line>
            <line x1="580" x2="720" y1="220" y2="220" stroke="#7a22ff" strokeWidth="6"></line>
            <line x1="500" x2="650" y1="350" y2="500" stroke="#7a22ff" strokeWidth="6"></line> 
            <line id="warning-skeletal-line" x1="500" x2="320" y1="350" y2="500" stroke="#ff3333" strokeWidth="8"></line> 
          </g>
          <g fill="white">
            <circle cx="500" cy="180" r="8" fill="#9d55ff"></circle>
            <circle cx="280" cy="220" r="6" fill="#7a22ff"></circle>
            <circle cx="720" cy="220" r="6" fill="#7a22ff"></circle>
            <circle cx="320" cy="500" r="8" fill="#ff3333"></circle>
          </g>
        </svg>
      </div>

      {/* رابط روی ویدیو دمو */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 20, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '16px', pointerEvents: 'none', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', width: '100%' }}>
          <div style={{ backgroundColor: 'rgba(17, 17, 22, 0.85)', backdropFilter: 'blur(12px)', padding: '10px 16px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '12px', border: '1px solid rgba(122, 34, 255, 0.2)' }}>
            <h2 style={{ fontSize: '15px', fontWeight: 'bold', color: '#ffffff', margin: 0 }}>حرکت جنگجو ۲</h2>
          </div>
          <div style={{ backgroundColor: 'rgba(17, 17, 22, 0.85)', backdropFilter: 'blur(12px)', padding: '6px 12px', borderRadius: '30px', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ width: '6px', height: '6px', backgroundColor: '#ff3333', borderRadius: '50%', display: 'inline-block' }}></span>
            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#ffffff' }}>دمو آنلاین POSE ESTIMATION</span>
          </div>
        </div>

        {/* فیدبک هوش مصنوعی بینوتک - همراه با آیکون SVG آفلاین */}
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <div style={{ backgroundColor: '#ff3333', color: '#ffffff', padding: '8px 24px', borderRadius: '30px', boxShadow: '0 8px 20px rgba(255, 51, 51, 0.3)', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold', fontSize: '13px' }}>
            {/* SVG آفلاین آیکون خطا */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>خطا: پای عقب خود را کاملاً صاف نگه‌دارید!</span>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
}

export default YogaDemo;